// extracted by mini-css-extract-plugin
var _1 = "RequestBoardCardTitle-moduleRequestBoardCardTitle__vPQvo";
var _2 = "RequestBoardCardTitle-moduleavatar__xEWDX";
var _3 = "RequestBoardCardTitle-moduletitle__MPIrv";
export { _1 as "RequestBoardCardTitle", _2 as "avatar", _3 as "title" }
